import { actions } from './discount_patient/actions'
import { getters } from './discount_patient/getters'
import { state } from './discount_patient/state'
import { mutations } from './discount_patient/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}
